// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"6c605576","437":"443042f9","518":"490fefea","539":"0bb3491b"}[chunkId] + ".chunk.css";
};